import React from 'react';
import { FaTextHeight } from 'react-icons/fa';

interface TextEditorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  language: 'ar' | 'en';
}

const TextEditor: React.FC<TextEditorProps> = ({
  label,
  value,
  onChange,
  language
}) => {
  const isRTL = language === 'ar';

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        <FaTextHeight className="inline mr-2" />
        {label}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        dir={isRTL ? 'rtl' : 'ltr'}
        placeholder={isRTL ? 'أدخل النص هنا...' : 'Enter text here...'}
      />
    </div>
  );
};

export default TextEditor; 